import { t } from '@life/i18n';
import { useEffect, useState } from 'preact/hooks';
import type { Clock } from '../state/clock';
import type { Game } from '../state/game';

/** Подсказки по порядку: с какого возраста показывать и что. Три и только три (D1). */
const HINTS: readonly { age: number; key: string }[] = [
  { age: 1, key: 'ui.hint.focus' },
  { age: 2, key: 'ui.hint.map' },
  { age: 3, key: 'ui.hint.envelope' },
];

/**
 * Подсказки первой жизни в режиме «Наблюдать», пока `settings.hintsSeen`
 * ложно (в режиме хода три подсказки встроены в `MorningCard`). Каждая висит, пока
 * её не закроют тапом (на ×16 год пролетает за секунду, поэтому показ не
 * привязан к одному году): очередная появляется, когда возраст дошёл до
 * её порога и предыдущая закрыта. Пока подсказка на экране, часы стоят
 * (`clock`); закрытие возвращает ход, если часы не стояли и до неё.
 * Закрытие третьей ставит `hintsSeen=true` (смерть — тоже, см. стор).
 * Сколько закрыто, помнит только компонент: перезагрузка покажет подсказки
 * сначала, это допустимо.
 */
export function Hints({ game, clock }: { game: Game; clock?: Clock }) {
  const [closed, setClosed] = useState(0);
  const life = game.life.value;
  const hint = HINTS[closed];
  const visible =
    life !== null && life.alive && !game.settings.value.hintsSeen && hint !== undefined && life.age >= hint.age;

  useEffect(() => {
    if (!visible || clock === undefined) return;
    const pausedBefore = clock.paused.value;
    clock.pause();
    return () => {
      if (!pausedBefore) clock.resume();
    };
  }, [visible, clock]);

  if (!visible) return null;

  const close = () => {
    setClosed(closed + 1);
    if (closed + 1 >= HINTS.length) {
      game.settings.value = { ...game.settings.value, hintsSeen: true };
    }
  };

  return (
    <div class="alert info hint-card" role="status">
      <p>{t(hint.key)}</p>
      <button type="button" class="btn" onClick={close}>
        {t('ui.hint.close')}
      </button>
    </div>
  );
}
